export default {
  // Nav
  'nav.home': 'Inicio',
  'nav.guide': 'Guía',
  'nav.shoppingGuide': 'Guía de compras',
  'nav.categories': 'Categorías',
  'nav.safety': 'Seguridad',
  'nav.brand': 'USFans Spreadsheet',

  // Hero
  'hero.eyebrow': 'EL CENTRO DE RECURSOS DE USFANS SPREADSHEET',
  'hero.title': 'USFans Spreadsheet — encuentra, organiza y explora información de creadores',
  'hero.subtitle':
    'Descubre recursos prácticos de hojas de cálculo USFans, guías de creadores, comparaciones, información de seguridad y herramientas útiles diseñadas para que la investigación de creadores sea más rápida, clara y fácil de organizar.',
  'hero.ctaPrimary': 'usfans spreadsheet',
  'hero.ctaSecondary': 'cómpralo ahora',
  'hero.trust': 'Recurso independiente · Guías prácticas · Enfocado en seguridad · Actualizado con regularidad',

  // Category section
  'category.title': 'Explora por categoría',
  'category.subtitle':
    'Salta directamente a la sección exacta de la tienda que necesitas. Elige una categoría abajo o usa el menú desplegable para navegar rápido.',
  'category.dropdownLabel': 'Selecciona una categoría',
  'category.browseAll': 'Explora todo el catálogo en la tienda',
  'category.featured': 'Categorías populares',

  // What is section
  'what.title': '¿Qué es una hoja de cálculo USFans?',
  'what.p1':
    'Una hoja de cálculo USFans es una forma estructurada de organizar la información sobre creadores en un solo lugar. En lugar de buscar en páginas dispersas, los usuarios pueden usar recursos organizados tipo hoja de cálculo para investigar, comparar y gestionar información de forma más eficiente.',
  'what.p2':
    'Nuestro Centro de Recursos de USFans Spreadsheet reúne guías prácticas, comparaciones, recursos de seguridad y contenido educativo para ayudar a los usuarios a entender cómo funcionan estos recursos y cómo usarlos de forma responsable.',
  'what.cta': 'Explora la guía de USFans Spreadsheet',

  // Benefits
  'benefit.title': '¿Por qué usar una hoja de cálculo USFans?',
  'benefit.subtitle': 'Ventajas prácticas que hacen que la investigación organizada sea más simple y fiable.',
  'benefit.1.title': 'Investigación organizada',
  'benefit.1.desc': 'Mantén la información relevante de los creadores estructurada y más fácil de revisar.',
  'benefit.2.title': 'Descubrimiento más rápido',
  'benefit.2.desc': 'Usa recursos organizados en lugar de depender solo de búsquedas dispersas.',
  'benefit.3.title': 'Comparación más fácil',
  'benefit.3.desc': 'Compara distintas fuentes de información con tablas claras y guías estructuradas.',
  'benefit.4.title': 'Mejores decisiones',
  'benefit.4.desc': 'Comprende qué significa la información antes de confiar en ella.',

  // Articles
  'articles.title': 'Últimas guías de USFans Spreadsheet',
  'articles.subtitle':
    'Guías originales y prácticas para entender, organizar y usar recursos de hojas de cálculo de forma segura.',
  'articles.readTime': '{{minutes}} min de lectura',
  'articles.updated': 'Actualizado',
  'articles.readMore': 'Leer artículo',
  'articles.related': 'Guías relacionadas',

  // Comparison
  'comparison.title': 'USFans Spreadsheet frente a otros métodos de descubrimiento',
  'comparison.subtitle': 'Mira cómo se comparan los recursos organizados con otras formas de investigar.',
  'comparison.method': 'Método',
  'comparison.organization': 'Organización',
  'comparison.searchability': 'Capacidad de búsqueda',
  'comparison.compare': 'Comparación',
  'comparison.bestFor': 'Ideal para',
  'comparison.row1.name': 'USFans Spreadsheet',
  'comparison.row2.name': 'Búsqueda manual',
  'comparison.row3.name': 'Directorio de creadores',
  'comparison.row4.name': 'Listas sin estructurar',
  'comparison.high': 'Alta',
  'comparison.medium': 'Media',
  'comparison.low': 'Baja',
  'comparison.row1.best': 'Investigación organizada',
  'comparison.row2.best': 'Búsquedas rápidas',
  'comparison.row3.best': 'Navegación',
  'comparison.row4.best': 'Referencia básica',
  'comparison.cta': 'Ver la comparación completa',

  // Safety
  'safety.title': 'Mantente seguro al usar recursos de hojas de cálculo en línea',
  'safety.subtitle': 'Unos pocos hábitos simples protegen tus datos y tu tranquilidad.',
  'safety.p1':
    'Nunca compartas contraseñas ni información sensible con sitios desconocidos. Verifica los enlaces antes de abrirlos, evita descargas sospechosas y trata con cautela las listas de creadores o afirmaciones no verificadas.',
  'safety.1': 'Verifica los enlaces antes de hacer clic',
  'safety.2': 'Nunca compartas contraseñas',
  'safety.3': 'Evita descargas sospechosas',
  'safety.4': 'Cuestiona las afirmaciones no verificadas',
  'safety.cta': 'Visita el Centro de Seguridad',

  // Final CTA
  'final.title': '¿Listo para explorar los recursos de USFans Spreadsheet?',
  'final.subtitle':
    'Empieza con la guía completa de USFans Spreadsheet y luego explora recursos de creadores, comparaciones e información de seguridad diseñada para que tu investigación sea más organizada.',
  'final.cta': 'Explora USFans Spreadsheet',

  // Footer
  'footer.tagline':
    'Un recurso informativo independiente sobre guías, comparaciones y seguridad de USFans Spreadsheet.',
  'footer.resources': 'Recursos',
  'footer.explore': 'Explora',
  'footer.legal': 'Legal',
  'footer.disclaimer':
    'USFanslink.makeup es un recurso informativo independiente. La información puede cambiar, los sitios de terceros pueden modificar sus políticas y los usuarios deben verificar la información importante por sí mismos.',
  'footer.rights': 'Todos los derechos reservados.',
  'footer.store': 'Visitar la tienda',

  // Categories
  'categories.shoes': 'Zapatos',
  'categories.hoodies': 'Sudaderas/Suéteres',
  'categories.tshirts': 'Camisetas',
  'categories.jackets': 'Chaquetas',
  'categories.pants': 'Pantalones/Shorts',
  'categories.headwear': 'Gorros y sombreros',
  'categories.sets': 'Conjuntos',
  'categories.underwear': 'Ropa interior',
  'categories.jersey': 'Camisetas deportivas',
  'categories.accessories': 'Accesorios',
  'categories.bags': 'Bolsos',
  'categories.belts': 'Cinturones',
  'categories.perfumes': 'Perfumes',
  'categories.other': 'Otras cosas',
};